import { render, staticRenderFns } from "./expert-needs.vue?vue&type=template&id=1858f5be&scoped=true"
import script from "./expert-needs.vue?vue&type=script&lang=js"
export * from "./expert-needs.vue?vue&type=script&lang=js"
import style0 from "./expert-needs.vue?vue&type=style&index=0&id=1858f5be&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1858f5be",
  null
  
)

export default component.exports